webpackJsonp([1],{

/***/ "6A3X":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8ZVo":
/***/ (function(module, exports) {

module.exports = [{"alias":"ntu","name":"臺灣大學","subcategories":["課程評價"]},{"alias":"nccu","name":"政治大學","subcategories":["課程評價"]},{"alias":"nctu","name":"交通大學","subcategories":["課程評價"]},{"alias":"tku","name":"淡江大學","subcategories":["課程評價"]},{"alias":"ndhu","name":"東華大學","subcategories":["課程評價"]},{"alias":"ncku","name":"成功大學","subcategories":["課程評價"]},{"alias":"ntut","name":"北科大","subcategories":["課程評價"]},{"alias":"fju","name":"輔仁大學","subcategories":["課程評價"]},{"alias":"ntnu","name":"師範大學","subcategories":["課程評價"]},{"alias":"nknu","name":"高雄師範大學","subcategories":["課程評價"]},{"alias":"ncue","name":"彰化師範大學","subcategories":["課程評價"]},{"alias":"ncu","name":"中央大學","subcategories":["課程評價"]},{"alias":"fcu","name":"逢甲大學","subcategories":["課程評價"]},{"alias":"nthu","name":"清華大學","subcategories":["課程評價"]},{"alias":"ncnu","name":"暨南大學","subcategories":["課程評價"]},{"alias":"thu","name":"東海大學","subcategories":["課程評價"]},{"alias":"nkfust","name":"高雄第一科大","subcategories":["課程評價"]},{"alias":"ntust","name":"台科大","subcategories":["課程評價"]},{"alias":"nchu","name":"中興大學","subcategories":["課程評價"]},{"alias":"yzu","name":"元智大學","subcategories":["課程評價"]},{"alias":"nuu","name":"聯合大學","subcategories":["課程評價"]},{"alias":"ntou","name":"海洋大學","subcategories":["課程評價"]},{"alias":"nsysu","name":"中山大學","subcategories":["課程評價"]},{"alias":"ntpu","name":"臺北大學","subcategories":["課程評價"]},{"alias":"cpu","name":"中央警察大學","subcategories":["課程評價"]},{"alias":"ccu","name":"中正大學","subcategories":["課程評價"]},{"alias":"usc","name":"實踐大學","subcategories":["課程評價"]},{"alias":"ym","name":"陽明大學","subcategories":["課程評價"]},{"alias":"ntua","name":"臺灣藝術大學","subcategories":["課程評價"]},{"alias":"shu","name":"世新大學","subcategories":["課程評價"]},{"alias":"ntue","name":"臺北教育大學","subcategories":["課程評價"]},{"alias":"tnua","name":"臺北藝術大學","subcategories":["課程評價"]},{"alias":"utaipei","name":"臺北市立大學","subcategories":["課程評價"]},{"alias":"pccu","name":"文化大學","subcategories":["課程評價"]},{"alias":"scu","name":"東吳大學","subcategories":["課程評價"]},{"alias":"ncyu","name":"嘉義大學","subcategories":["課程評價"]},{"alias":"nuk","name":"高雄大學","subcategories":["課程評價"]},{"alias":"nutc","name":"中科大","subcategories":["課程評價"]},{"alias":"ntunhs","name":"國北護","subcategories":["課程評價"]},{"alias":"isu","name":"義守大學","subcategories":["課程評價"]},{"alias":"cgu","name":"長庚大學","subcategories":["課程評價"]},{"alias":"tmu","name":"臺北醫學大學","subcategories":["課程評價"]},{"alias":"cycu","name":"中原大學","subcategories":["課程評價"]},{"alias":"csmu","name":"中山醫學大學","subcategories":["課程評價"]},{"alias":"wzu","name":"文藻外語大學","subcategories":["課程評價"]},{"alias":"kuas","name":"高應大","subcategories":["課程評價"]},{"alias":"cgust","name":"長庚科大","subcategories":["課程評價"]},{"alias":"ncut","name":"勤益科大","subcategories":["課程評價"]},{"alias":"mcu","name":"銘傳大學","subcategories":["課程評價"]},{"alias":"niu","name":"宜蘭大學","subcategories":["課程評價"]},{"alias":"nfu","name":"虎尾科大","subcategories":["課程評價"]},{"alias":"nhcue","name":"新竹教育大學","subcategories":["課程評價"]},{"alias":"ttu","name":"大同大學","subcategories":["課程評價"]},{"alias":"ntub","name":"臺北商業大學","subcategories":["課程評價"]},{"alias":"ntcu","name":"臺中教育大學","subcategories":["課程評價"]},{"alias":"nptu","name":"屏東大學","subcategories":["課程評價"]},{"alias":"pu","name":"靜宜大學","subcategories":["課程評價"]},{"alias":"nkmu","name":"高雄海洋科大","subcategories":["課程評價"]},{"alias":"cyut","name":"朝陽科大","subcategories":["課程評價"]},{"alias":"ndu","name":"國防大學","subcategories":["課程評價"]},{"alias":"stust","name":"南臺科大","subcategories":["課程評價"]},{"alias":"nkuht","name":"高雄餐旅大學","subcategories":["課程評價"]},{"alias":"cmu","name":"中國醫藥大學","subcategories":["課程評價"]},{"alias":"cjcu","name":"長榮大學","subcategories":["課程評價"]},{"alias":"npust","name":"屏科大","subcategories":["課程評價"]},{"alias":"mcut","name":"明志科大","subcategories":["課程評價"]},{"alias":"asia","name":"亞洲大學","subcategories":["課程評價"]},{"alias":"uch","name":"健行科大","subcategories":["課程評價"]},{"alias":"stu","name":"樹德科技大學","subcategories":["課程評價"]},{"alias":"au","name":"真理大學","subcategories":["課程評價"]},{"alias":"cnu","name":"嘉南藥理大學","subcategories":["課程評價"]},{"alias":"kmu","name":"高雄醫學大學","subcategories":["課程評價"]},{"alias":"must","name":"明新科技大學","subcategories":["課程評價"]},{"alias":"nttu","name":"臺東大學","subcategories":["課程評價"]},{"alias":"tut","name":"台南應用科大","subcategories":["課程評價"]},{"alias":"nqu","name":"金門大學","subcategories":["課程評價"]},{"alias":"dyu","name":"大葉大學","subcategories":["課程評價"]},{"alias":"nhu","name":"南華大學","subcategories":["課程評價"]},{"alias":"ltu","name":"嶺東科大","subcategories":["課程評價"]},{"alias":"fy","name":"輔英科技大學","subcategories":["課程評價"]},{"alias":"cute","name":"中國科大","subcategories":["課程評價"]},{"alias":"tcust","name":"慈濟科技大學","subcategories":["課程評價"]},{"alias":"tcu","name":"慈濟大學","subcategories":["課程評價"]},{"alias":"chihlee","name":"致理科技大學","subcategories":["課程評價"]},{"alias":"knu","name":"開南大學","subcategories":["課程評價"]},{"alias":"hk","name":"弘光科技大學","subcategories":["課程評價"]},{"alias":"nutn","name":"臺南大學","subcategories":["課程評價"]},{"alias":"chu","name":"中華大學","subcategories":["課程評價"]},{"alias":"takming","name":"德明財經科大","subcategories":["課程評價"]},{"alias":"just","name":"景文科大","subcategories":["課程評價"]},{"alias":"delete","name":"刪文","subcategories":[]},{"alias":"lhu","name":"龍華科技大學","subcategories":["課程評價"]},{"alias":"yuntech","name":"國立雲林科技大學","subcategories":["課程評價"]},{"alias":"csu","name":"正修科大","subcategories":["課程評價"]},{"alias":"feu","name":"遠東科大","subcategories":["課程評價"]},{"alias":"wfu","name":"吳鳳科大","subcategories":["課程評價"]},{"alias":"ctust","name":"中臺科大","subcategories":["課程評價"]},{"alias":"npu","name":"國立澎湖科技大學","subcategories":["課程評價"]},{"alias":"ksu","name":"崑山科大","subcategories":["課程評價"]},{"alias":"twu","name":"環球科技大學","subcategories":["課程評價"]},{"alias":"hwai","name":"中華醫事科技大學","subcategories":["課程評價"]},{"alias":"ocu","name":"僑光科技大學","subcategories":["課程評價"]},{"alias":"ntupes","name":"臺灣體育運動大學","subcategories":["課程評價"]},{"alias":"hwu","name":"醒吾科技大學","subcategories":["課程評價"]},{"alias":"hfu","name":"華梵大學","subcategories":["課程評價"]},{"alias":"fgu","name":"佛光大學","subcategories":["課程評價"]},{"alias":"vnu","name":"萬能科大","subcategories":["課程評價"]},{"alias":"oit","name":"亞東技術學院","subcategories":["課程評價"]},{"alias":"cku","name":"經國管理暨健康學院","subcategories":["課程評價"]},{"alias":"ctu","name":"建國科大","subcategories":["課程評價"]},{"alias":"tnu","name":"東南科大","subcategories":["課程評價"]},{"alias":"nkut","name":"南開科大","subcategories":["課程評價"]},{"alias":"sju","name":"聖約翰科大","subcategories":["課程評價"]},{"alias":"mdu","name":"明道大學","subcategories":["課程評價"]},{"alias":"meiho","name":"美和科大","subcategories":["課程評價"]},{"alias":"tnnua","name":"臺南藝術大學","subcategories":["課程評價"]},{"alias":"ukn","name":"康寧大學","subcategories":["課程評價"]},{"alias":"ydu","name":"育達科大","subcategories":["課程評價"]},{"alias":"kyu","name":"高苑科大","subcategories":["課程評價"]},{"alias":"cust","name":"中華科大","subcategories":["課程評價"]},{"alias":"ypu","name":"元培醫事科大","subcategories":["課程評價"]},{"alias":"ntsu","name":"國立體育大學","subcategories":["課程評價"]},{"alias":"tajen","name":"大仁科大","subcategories":["課程評價"]},{"alias":"tsu","name":"台灣首府大學","subcategories":["課程評價"]},{"alias":"hcu","name":"玄奘大學","subcategories":["課程評價"]},{"alias":"nju","name":"南榮科大","subcategories":["課程評價"]},{"alias":"ccut","name":"中州科大","subcategories":["課程評價"]},{"alias":"hwh","name":"華夏科大","subcategories":["課程評價"]},{"alias":"hust","name":"修平科大","subcategories":["課程評價"]},{"alias":"tust","name":"大華科大","subcategories":["課程評價"]},{"alias":"tpcu","name":"臺北城市科大","subcategories":["課程評價"]},{"alias":"mmc","name":"馬偕醫學院","subcategories":["課程評價"]},{"alias":"dlit","name":"德霖技術學院","subcategories":["課程評價"]},{"alias":"tcmt","name":"台北海洋技術學院","subcategories":["課程評價"]},{"alias":"tiit","name":"南亞技術學院","subcategories":["課程評價"]},{"alias":"tcpa","name":"臺灣戲曲學院","subcategories":["課程評價"]},{"alias":"lit","name":"黎明技術學院","subcategories":["課程評價"]},{"alias":"toko","name":"稻江科技暨管理學院","subcategories":["課程評價"]},{"alias":"fotech","name":"和春技術學院","subcategories":["課程評價"]},{"alias":"dila","name":"法鼓文理學院","subcategories":["課程評價"]},{"alias":"tht","name":"臺灣觀光學院","subcategories":["課程評價"]},{"alias":"apic","name":"亞太創意技術學院","subcategories":["課程評價"]},{"alias":"fit","name":"蘭陽技術學院","subcategories":["課程評價"]},{"alias":"ttc","name":"大同技術學院","subcategories":["課程評價"]},{"alias":"dahan","name":"大漢技術學院","subcategories":["課程評價"]},{"alias":"cit","name":"崇右技術學院","subcategories":["課程評價"]},{"alias":"tf","name":"東方設計學院","subcategories":["課程評價"]},{"alias":"kmvs","name":"高美醫護管理專科學校","subcategories":["課程評價"]},{"alias":"ntin","name":"國立臺南護理專科學校","subcategories":["課程評價"]},{"alias":"szmc","name":"樹人醫護管理專科學校","subcategories":["課程評價"]},{"alias":"yuhing","name":"育英醫護管理專科學校","subcategories":["課程評價"]},{"alias":"smc","name":"聖母醫護管理專科學校","subcategories":["課程評價"]},{"alias":"cjc","name":"崇仁醫護管理專科學校","subcategories":["課程評價"]},{"alias":"knjc","name":"康寧醫護暨管理專科學校","subcategories":["課程評價"]},{"alias":"tzuhui","name":"慈惠醫護管理專科學校","subcategories":["課程評價"]},{"alias":"ctcn","name":"耕莘健康管理專科學校","subcategories":["課程評價"]},{"alias":"hsc","name":"新生醫護管理專科學校","subcategories":["課程評價"]},{"alias":"mhchcm","name":"敏惠醫護管理專科學校","subcategories":["課程評價"]},{"alias":"mkc","name":"馬偕醫護管理專科學校","subcategories":["課程評價"]},{"alias":"jente","name":"仁德醫護管理專科學校","subcategories":["課程評價"]},{"alias":"ndmctsgh","name":"國防醫學院","subcategories":["課程評價"]}]

/***/ }),

/***/ "CuW/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IRIP":
/***/ (function(module, exports) {

module.exports = [{"alias":"timecapsule","name":"時光膠囊","subcategories":[]},{"alias":"vehicle","name":"汽機車","subcategories":["保養","改裝","購車選擇","配件部品","車禍處理"]},{"alias":"language","name":"語言","subcategories":["英語","日語","韓語","歐語"]},{"alias":"freshman","name":"新生季","subcategories":[]},{"alias":"father","name":"父親節","subcategories":[]},{"alias":"relationship","name":"感情","subcategories":["曖昧","告白","閃光","劈腿","失戀","分手"]},{"alias":"girl","name":"女孩","subcategories":["網購","髮型","心事"]},{"alias":"makeup","name":"美妝","subcategories":["底妝","眼妝","唇彩","保養","情報"]},{"alias":"dressup","name":"穿搭","subcategories":["日常","正式","情侶","鞋款"]},{"alias":"funny","name":"有趣","subcategories":[]},{"alias":"rainbow","name":"彩虹","subcategories":["心情","議題"]},{"alias":"marvel","name":"靈異","subcategories":["親身經歷","海龜湯","連載"]},{"alias":"boy","name":"男孩","subcategories":["表特","軍旅","心事"]},{"alias":"horoscopes","name":"星座","subcategories":["占卜","心理測驗","白羊","金牛","雙子","巨蟹","獅子","處女","天秤","天蠍","射手","摩羯","水瓶","雙魚"]},{"alias":"food","name":"美食","subcategories":["食譜","食記","評比","超商"]},{"alias":"mood","name":"心情","subcategories":[]},{"alias":"pet","name":"寵物","subcategories":["協尋","狗","貓","小動物","爬蟲","水族"]},{"alias":"handicrafts","name":"手作","subcategories":["手創","廢物利用","繪畫","紙藝","鋼筆","工藝"]},{"alias":"trending","name":"時事","subcategories":["新聞","討論","爆料","社論"]},{"alias":"talk","name":"閒聊","subcategories":["理財","醫療","法律"]},{"alias":"acg","name":"動漫","subcategories":["情報","心得","推坑","腐","同人","COS"]},{"alias":"game","name":"遊戲","subcategories":["LOL","OW","手遊"]},{"alias":"pokemon","name":"寶可夢","subcategories":[]},{"alias":"movie","name":"影劇","subcategories":["情報","電影","臺灣","韓國","歐美","日本","中國"]},{"alias":"photography","name":"攝影","subcategories":["底片","手機","單眼","器材"]},{"alias":"3c","name":"3C","subcategories":["電腦","手機","音響","教學"]},{"alias":"job","name":"工作","subcategories":["徵才","經驗分享","職業介紹","勞工權益"]},{"alias":"music","name":"音樂","subcategories":["創作","東洋","西洋","樂器"]},{"alias":"sport","name":"運動","subcategories":["健身","籃球","棒球","排球"]},{"alias":"travel","name":"旅遊","subcategories":["臺灣","日韓","亞洲","歐美"]},{"alias":"mother","name":"母親節","subcategories":[]},{"alias":"book","name":"書籍","subcategories":["教科書","小說"]},{"alias":"studyabroad","name":"留學","subcategories":["申請","生活","考試","打工度假"]},{"alias":"literature","name":"詩文","subcategories":["新詩","散文","小說","詞創"]},{"alias":"exam","name":"考試","subcategories":["轉學考","國考","重考","考古題"]},{"alias":"course","name":"課程","subcategories":[]},{"alias":"bugreport","name":"臨時回報","subcategories":[]},{"alias":"ecofriendly","name":"無痕飲食","subcategories":[]},{"alias":"sex","name":"西斯","subcategories":["創作","知識","圖文"]},{"alias":"dcard","name":"Dcard","subcategories":[]},{"alias":"whysoserious","name":"廢文","subcategories":[]},{"alias":"graduate","name":"畢業季","subcategories":[]}]

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/fastclick/lib/fastclick.js
var fastclick = __webpack_require__("v5o6");
var fastclick_default = /*#__PURE__*/__webpack_require__.n(fastclick);

// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// EXTERNAL MODULE: ./node_modules/object-assign/index.js
var object_assign = __webpack_require__("BEQ0");
var object_assign_default = /*#__PURE__*/__webpack_require__.n(object_assign);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-header/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var x_header = ({
  name: 'x-header',
  props: {
    leftOptions: Object,
    title: String,
    transition: String,
    rightOptions: {
      type: Object,
      default: function _default() {
        return {
          showMore: false
        };
      }
    }
  },
  beforeMount: function beforeMount() {
    if (this.$slots['overwrite-title']) {
      this.shouldOverWriteTitle = true;
    }
  },

  computed: {
    _leftOptions: function _leftOptions() {
      return object_assign_default()({
        showBack: true,
        preventGoBack: false
      }, this.leftOptions || {});
    }
  },
  methods: {
    onClickBack: function onClickBack() {
      if (this._leftOptions.preventGoBack) {
        this.$emit('on-click-back');
      } else {
        this.$router ? this.$router.back() : window.history.back();
      }
    }
  },
  data: function data() {
    return {
      shouldOverWriteTitle: false
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-header/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_x_header = ({
  name: 'x-header',
  props: {
    leftOptions: Object,
    title: String,
    transition: String,
    rightOptions: {
      type: Object,
      default: function _default() {
        return {
          showMore: false
        };
      }
    }
  },
  beforeMount: function beforeMount() {
    if (this.$slots['overwrite-title']) {
      this.shouldOverWriteTitle = true;
    }
  },

  computed: {
    _leftOptions: function _leftOptions() {
      return object_assign_default()({
        showBack: true,
        preventGoBack: false
      }, this.leftOptions || {});
    }
  },
  methods: {
    onClickBack: function onClickBack() {
      if (this._leftOptions.preventGoBack) {
        this.$emit('on-click-back');
      } else {
        this.$router ? this.$router.back() : window.history.back();
      }
    }
  },
  data: function data() {
    return {
      shouldOverWriteTitle: false
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-eb223dbe","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/x-header/index.vue
var x_header_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-header"},[_c('div',{staticClass:"vux-header-left"},[_vm._t("overwrite-left",[_c('transition',{attrs:{"name":_vm.transition}},[_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm._leftOptions.showBack),expression:"_leftOptions.showBack"}],staticClass:"vux-header-back",on:{"click":[function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"preventDefault",undefined,$event.key,undefined)){ return null; }},_vm.onClickBack]}},[_vm._v(_vm._s(typeof _vm._leftOptions.backText === 'undefined' ? '返回' : _vm._leftOptions.backText))])]),_vm._v(" "),_c('transition',{attrs:{"name":_vm.transition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm._leftOptions.showBack),expression:"_leftOptions.showBack"}],staticClass:"left-arrow",on:{"click":_vm.onClickBack}})])]),_vm._v(" "),_vm._t("left")],2),_vm._v(" "),(!_vm.shouldOverWriteTitle)?_c('h1',{staticClass:"vux-header-title",on:{"click":function($event){_vm.$emit('on-click-title')}}},[_vm._t("default",[_c('transition',{attrs:{"name":_vm.transition}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.title),expression:"title"}]},[_vm._v(_vm._s(_vm.title))])])])],2):_vm._e(),_vm._v(" "),(_vm.shouldOverWriteTitle)?_c('div',{staticClass:"vux-header-title-area"},[_vm._t("overwrite-title")],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"vux-header-right"},[(_vm.rightOptions.showMore)?_c('a',{staticClass:"vux-header-more",on:{"click":[function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"preventDefault",undefined,$event.key,undefined)){ return null; }},function($event){_vm.$emit('on-click-more')}]}}):_vm._e(),_vm._v(" "),_vm._t("right")],2)])}
var staticRenderFns = []
var esExports = { render: x_header_render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_x_header = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/x-header/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("owug")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_x_header,
  src_components_x_header,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)


/* harmony default export */ var vux_src_components_x_header = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/drawer/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var drawer = ({
  name: 'drawer',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    placement: {
      type: String,
      default: 'left'
    },
    showMode: {
      type: String,
      default: 'overlay'
    },
    drawerStyle: Object
  },
  data: function data() {
    return {
      drawerWidth: 0,
      translateX: 0
    };
  },

  watch: {
    show: function show() {
      if (!this.show) {
        this.$emit('on-hide');
      } else {
        this.$emit('on-show');
      }
      if (this.showMode === 'overlay') {
        return;
      }
      if (!this.show) {
        this.translateX = 0;
      } else {
        this.translateX = this.placement === 'left' ? this.drawerWidth : -this.drawerWidth;
      }
    }
  },
  methods: {
    hideMask: function hideMask() {
      this.$emit('update:show', false);
    }
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      this.drawerWidth = this.$refs.drawer.clientWidth;
    });
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/drawer/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var components_drawer = ({
  name: 'drawer',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    placement: {
      type: String,
      default: 'left'
    },
    showMode: {
      type: String,
      default: 'overlay'
    },
    drawerStyle: Object
  },
  data: function data() {
    return {
      drawerWidth: 0,
      translateX: 0
    };
  },

  watch: {
    show: function show() {
      if (!this.show) {
        this.$emit('on-hide');
      } else {
        this.$emit('on-show');
      }
      if (this.showMode === 'overlay') {
        return;
      }
      if (!this.show) {
        this.translateX = 0;
      } else {
        this.translateX = this.placement === 'left' ? this.drawerWidth : -this.drawerWidth;
      }
    }
  },
  methods: {
    hideMask: function hideMask() {
      this.$emit('update:show', false);
    }
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      this.drawerWidth = this.$refs.drawer.clientWidth;
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-54c146b4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/drawer/index.vue
var drawer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-drawer"},[_c('div',{staticClass:"vux-drawer-body",style:({transform: ("translate3d(" + _vm.translateX + "px, 0, 0)")})},[_vm._t("default"),_vm._v(" "),_c('div',{staticClass:"drawer-mask",class:_vm.show ? 'vux-drawer-active' : '',on:{"click":_vm.hideMask}})],2),_vm._v(" "),_c('div',{ref:"drawer",staticClass:"vux-drawer-content",class:[_vm.placement !=='left' ? 'drawer-right' : 'drawer-left', _vm.show ? 'vux-drawer-active' : ''],style:(_vm.drawerStyle)},[_vm._t("drawer")],2)])}
var drawer_staticRenderFns = []
var drawer_esExports = { render: drawer_render, staticRenderFns: drawer_staticRenderFns }
/* harmony default export */ var src_components_drawer = (drawer_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/drawer/index.vue
function drawer_injectStyle (ssrContext) {
  __webpack_require__("tH2/")
}
var drawer_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var drawer___vue_template_functional__ = false
/* styles */
var drawer___vue_styles__ = drawer_injectStyle
/* scopeId */
var drawer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var drawer___vue_module_identifier__ = null
var drawer_Component = drawer_normalizeComponent(
  components_drawer,
  src_components_drawer,
  drawer___vue_template_functional__,
  drawer___vue_styles__,
  drawer___vue_scopeId__,
  drawer___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_drawer = (drawer_Component.exports);

// EXTERNAL MODULE: ./src/components/school.json
var school = __webpack_require__("8ZVo");
var school_default = /*#__PURE__*/__webpack_require__.n(school);

// EXTERNAL MODULE: ./src/components/forum.json
var forum = __webpack_require__("IRIP");
var forum_default = /*#__PURE__*/__webpack_require__.n(forum);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue







/* harmony default export */ var App = ({
  name: 'app',
  components: {
    XHeader: vux_src_components_x_header, Drawer: vux_src_components_drawer
  },
  data: function data() {
    return {
      drawerVisibility: false,
      showMode: 'push',
      check: '',
      schools: school_default.a,
      forums: forum_default.a,
      type1: false,
      type2: false
    };
  },

  methods: {
    isShowNav: function isShowNav() {
      if (this.entryUrl.indexOf('hide-nav') > -1) {
        return false;
      }
      return true;
    },
    goBack: function goBack() {
      history.go(-1);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue







/* harmony default export */ var selectortype_script_index_0_src_App = ({
  name: 'app',
  components: {
    XHeader: vux_src_components_x_header, Drawer: vux_src_components_drawer
  },
  data: function data() {
    return {
      drawerVisibility: false,
      showMode: 'push',
      check: '',
      schools: school_default.a,
      forums: forum_default.a,
      type1: false,
      type2: false
    };
  },

  methods: {
    isShowNav: function isShowNav() {
      if (this.entryUrl.indexOf('hide-nav') > -1) {
        return false;
      }
      return true;
    },
    goBack: function goBack() {
      history.go(-1);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-714c5488","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"100%"},attrs:{"id":"app"},on:{"contextmenu":function($event){$event.preventDefault();}}},[_c('x-header',{staticStyle:{"width":"100%","position":"absolute","left":"0","top":"0","z-index":"100","background-color":"rgb(15, 107, 164)","/*background-color":"rgb(0, 106, 166)*/"},style:(_vm.check)},[_c('span',[_vm._v("V-Dcard")]),_vm._v(" "),_c('svg',{staticClass:"vux-x-icon vux-x-icon-navicon",staticStyle:{"fill":"#fff","position":"relative","top":"-8px","left":"-3px"},attrs:{"slot":"overwrite-left","type":"navicon","size":"40","xmlns":"http://www.w3.org/2000/svg","width":"40","height":"40","viewBox":"0 0 512 512"},on:{"click":function($event){_vm.drawerVisibility = !_vm.drawerVisibility}},slot:"overwrite-left"},[_c('path',{attrs:{"d":"M96 241h320v32H96zm0-96h320v32H96zm0 192h320v32H96z"}})])]),_vm._v(" "),_c('svg',{staticClass:"vux-x-icon vux-x-icon-ios-arrow-thin-left",staticStyle:{"position":"absolute","bottom":"20","right":"20","border":"1px solid rgb(15, 107, 164)","border-radius":"100%","z-index":"100"},attrs:{"type":"ios-arrow-thin-left","size":"40","xmlns":"http://www.w3.org/2000/svg","width":"40","height":"40","viewBox":"0 0 512 512"},on:{"click":_vm.goBack}},[_c('path',{attrs:{"d":"M189.8 349.7c3.1-3.1 3-8 0-11.3L123.4 264H408c4.4 0 8-3.6 8-8s-3.6-8-8-8H123.4l66.3-74.4c2.9-3.4 3.2-8.1.1-11.2-3.1-3.1-8.5-3.3-11.4-.1 0 0-79.2 87-80 88S96 253.1 96 256s1.6 4.9 2.4 5.7 80 88 80 88c1.5 1.5 3.6 2.3 5.7 2.3s4.1-.8 5.7-2.3z"}})]),_vm._v(" "),_c('drawer',{attrs:{"width":"200px;","show":_vm.drawerVisibility,"show-mode":"push","drawer-style":{'-webkit-overflow-scrolling':'touch','background-color':/*'rgb(0, 45, 70)'*/'#00325f' ,width: '70vw','overflow':'scroll','padding-top':'46px'}},on:{"update:show":function($event){_vm.drawerVisibility=$event}}},[_c('div',{attrs:{"slot":"drawer"},slot:"drawer"},[_c('br'),_vm._v(" "),_c('ul',[_c('li',[_c('router-link',{staticClass:"forum",attrs:{"to":"/"},nativeOn:{"click":function($event){_vm.drawerVisibility = false}}},[_vm._v("全部")])],1),_vm._v(" "),_c('li',[_c('a',{staticClass:"forum",attrs:{"href":"https://github.com/realdennis/v-dcard"},on:{"click":function($event){_vm.drawerVisibility = false}}},[_vm._v("Github")])])]),_vm._v(" "),_c('p',{staticStyle:{"color":"hsla(0,0%,100%,.6)","margin":"10px"},on:{"click":function($event){_vm.type1 = !_vm.type1}}},[_vm._v("分類看板")]),_vm._v(" "),_c('transition',{attrs:{"name":"slide-fade"}},[(_vm.type1)?_c('ul',_vm._l((_vm.forums),function(f){return _c('li',[_c('router-link',{staticClass:"forum",attrs:{"to":'/'+f.alias},nativeOn:{"click":function($event){_vm.drawerVisibility = false}}},[_vm._v(_vm._s(f.name))])],1)})):_vm._e()]),_vm._v(" "),_c('p',{staticStyle:{"color":"hsla(0,0%,100%,.6)","margin":"10px"},on:{"click":function($event){_vm.type2 = !_vm.type2}}},[_vm._v("校園看板")]),_vm._v(" "),_c('transition',{attrs:{"name":"slide-fade"}},[(_vm.type2)?_c('ul',_vm._l((_vm.schools),function(s){return _c('li',[_c('router-link',{staticClass:"forum",attrs:{"to":'/'+s.alias},nativeOn:{"click":function($event){_vm.drawerVisibility = false}}},[_vm._v(_vm._s(s.name))])],1)})):_vm._e()]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br')],1),_vm._v(" "),_c('div',{attrs:{"id":"router-post"}},[_c('router-view')],1)])],1)}
var App_staticRenderFns = []
var App_esExports = { render: App_render, staticRenderFns: App_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (App_esExports);
// CONCATENATED MODULE: ./src/App.vue
function App_injectStyle (ssrContext) {
  __webpack_require__("y1Ni")
}
var App_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var App___vue_template_functional__ = false
/* styles */
var App___vue_styles__ = App_injectStyle
/* scopeId */
var App___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var App___vue_module_identifier__ = null
var App_Component = App_normalizeComponent(
  selectortype_script_index_0_src_App,
  selectortype_template_index_0_src_App,
  App___vue_template_functional__,
  App___vue_styles__,
  App___vue_scopeId__,
  App___vue_module_identifier__
)

/* harmony default export */ var src_App = (App_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/inline-loading/index.vue
//
//
//
//

/* harmony default export */ var inline_loading = ({
  name: 'inline-loading'
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/inline-loading/index.vue
//
//
//
//

/* harmony default export */ var components_inline_loading = ({
  name: 'inline-loading'
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-137803b6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/inline-loading/index.vue
var inline_loading_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{staticClass:"weui-loading"})}
var inline_loading_staticRenderFns = []
var inline_loading_esExports = { render: inline_loading_render, staticRenderFns: inline_loading_staticRenderFns }
/* harmony default export */ var src_components_inline_loading = (inline_loading_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/inline-loading/index.vue
function inline_loading_injectStyle (ssrContext) {
  __webpack_require__("c9+y")
}
var inline_loading_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var inline_loading___vue_template_functional__ = false
/* styles */
var inline_loading___vue_styles__ = inline_loading_injectStyle
/* scopeId */
var inline_loading___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var inline_loading___vue_module_identifier__ = null
var inline_loading_Component = inline_loading_normalizeComponent(
  components_inline_loading,
  src_components_inline_loading,
  inline_loading___vue_template_functional__,
  inline_loading___vue_styles__,
  inline_loading___vue_scopeId__,
  inline_loading___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_inline_loading = (inline_loading_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/mixins/multi-items.js + 1 modules
var multi_items = __webpack_require__("piuB");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/tab/tab.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var tab = ({
  name: 'tab',
  mixins: [multi_items["b" /* parentMixin */]],
  mounted: function mounted() {
    var _this = this;

    // stop bar anmination on first loading
    this.$nextTick(function () {
      setTimeout(function () {
        _this.hasReady = true;
      }, 0);
    });
  },

  props: {
    lineWidth: {
      type: Number,
      default: 3
    },
    activeColor: String,
    barActiveColor: String,
    defaultColor: String,
    disabledColor: String,
    animate: {
      type: Boolean,
      default: true
    },
    customBarWidth: [Function, String],
    preventDefault: Boolean,
    scrollThreshold: {
      type: Number,
      default: 4
    },
    barPosition: {
      type: String,
      default: 'bottom',
      validator: function validator(val) {
        return ['bottom', 'top'].indexOf(val) !== -1;
      }
    }
  },
  computed: {
    barLeft: function barLeft() {
      if (this.hasReady) {
        var count = this.scrollable ? window.innerWidth / this.$children[this.currentIndex || 0].$el.getBoundingClientRect().width : this.number;
        return this.currentIndex * (100 / count) + '%';
      }
    },
    barRight: function barRight() {
      if (this.hasReady) {
        var count = this.scrollable ? window.innerWidth / this.$children[this.currentIndex || 0].$el.getBoundingClientRect().width : this.number;
        return (count - this.currentIndex - 1) * (100 / count) + '%';
      }
    },

    // when prop:custom-bar-width
    innerBarStyle: function innerBarStyle() {
      return {
        width: typeof this.customBarWidth === 'function' ? this.customBarWidth(this.currentIndex) : this.customBarWidth,
        backgroundColor: this.barActiveColor || this.activeColor
      };
    },

    // end
    barStyle: function barStyle() {
      var commonStyle = {
        left: this.barLeft,
        right: this.barRight,
        display: 'block',
        height: this.lineWidth + 'px',
        transition: !this.hasReady ? 'none' : null
      };
      if (!this.customBarWidth) {
        commonStyle.backgroundColor = this.barActiveColor || this.activeColor;
      } else {
        commonStyle.backgroundColor = 'transparent'; // when=prop:custom-bar-width
      }
      return commonStyle;
    },
    barClass: function barClass() {
      return {
        'vux-tab-ink-bar-transition-forward': this.direction === 'forward',
        'vux-tab-ink-bar-transition-backward': this.direction === 'backward'
      };
    },
    scrollable: function scrollable() {
      return this.number > this.scrollThreshold;
    }
  },
  watch: {
    currentIndex: function currentIndex(newIndex, oldIndex) {
      this.direction = newIndex > oldIndex ? 'forward' : 'backward';
      this.$emit('on-index-change', newIndex, oldIndex);
      this.hasReady && this.scrollToActiveTab();
    }
  },
  data: function data() {
    return {
      direction: 'forward',
      right: '100%',
      hasReady: false
    };
  },

  methods: {
    scrollToActiveTab: function scrollToActiveTab() {
      var _this2 = this;

      if (!this.scrollable || !this.$children || !this.$children.length) {
        return;
      }
      var currentIndexTab = this.$children[this.currentIndex].$el;
      var count = 0;
      // scroll animation
      var step = function step() {
        var scrollDuration = 15;
        var nav = _this2.$refs.nav;
        nav.scrollLeft += (currentIndexTab.offsetLeft - (nav.offsetWidth - currentIndexTab.offsetWidth) / 2 - nav.scrollLeft) / scrollDuration;
        if (++count < scrollDuration) {
          window.requestAnimationFrame(step);
        }
      };
      window.requestAnimationFrame(step);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/tab/tab.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var tab_tab = ({
  name: 'tab',
  mixins: [multi_items["b" /* parentMixin */]],
  mounted: function mounted() {
    var _this = this;

    // stop bar anmination on first loading
    this.$nextTick(function () {
      setTimeout(function () {
        _this.hasReady = true;
      }, 0);
    });
  },

  props: {
    lineWidth: {
      type: Number,
      default: 3
    },
    activeColor: String,
    barActiveColor: String,
    defaultColor: String,
    disabledColor: String,
    animate: {
      type: Boolean,
      default: true
    },
    customBarWidth: [Function, String],
    preventDefault: Boolean,
    scrollThreshold: {
      type: Number,
      default: 4
    },
    barPosition: {
      type: String,
      default: 'bottom',
      validator: function validator(val) {
        return ['bottom', 'top'].indexOf(val) !== -1;
      }
    }
  },
  computed: {
    barLeft: function barLeft() {
      if (this.hasReady) {
        var count = this.scrollable ? window.innerWidth / this.$children[this.currentIndex || 0].$el.getBoundingClientRect().width : this.number;
        return this.currentIndex * (100 / count) + '%';
      }
    },
    barRight: function barRight() {
      if (this.hasReady) {
        var count = this.scrollable ? window.innerWidth / this.$children[this.currentIndex || 0].$el.getBoundingClientRect().width : this.number;
        return (count - this.currentIndex - 1) * (100 / count) + '%';
      }
    },

    // when prop:custom-bar-width
    innerBarStyle: function innerBarStyle() {
      return {
        width: typeof this.customBarWidth === 'function' ? this.customBarWidth(this.currentIndex) : this.customBarWidth,
        backgroundColor: this.barActiveColor || this.activeColor
      };
    },

    // end
    barStyle: function barStyle() {
      var commonStyle = {
        left: this.barLeft,
        right: this.barRight,
        display: 'block',
        height: this.lineWidth + 'px',
        transition: !this.hasReady ? 'none' : null
      };
      if (!this.customBarWidth) {
        commonStyle.backgroundColor = this.barActiveColor || this.activeColor;
      } else {
        commonStyle.backgroundColor = 'transparent'; // when=prop:custom-bar-width
      }
      return commonStyle;
    },
    barClass: function barClass() {
      return {
        'vux-tab-ink-bar-transition-forward': this.direction === 'forward',
        'vux-tab-ink-bar-transition-backward': this.direction === 'backward'
      };
    },
    scrollable: function scrollable() {
      return this.number > this.scrollThreshold;
    }
  },
  watch: {
    currentIndex: function currentIndex(newIndex, oldIndex) {
      this.direction = newIndex > oldIndex ? 'forward' : 'backward';
      this.$emit('on-index-change', newIndex, oldIndex);
      this.hasReady && this.scrollToActiveTab();
    }
  },
  data: function data() {
    return {
      direction: 'forward',
      right: '100%',
      hasReady: false
    };
  },

  methods: {
    scrollToActiveTab: function scrollToActiveTab() {
      var _this2 = this;

      if (!this.scrollable || !this.$children || !this.$children.length) {
        return;
      }
      var currentIndexTab = this.$children[this.currentIndex].$el;
      var count = 0;
      // scroll animation
      var step = function step() {
        var scrollDuration = 15;
        var nav = _this2.$refs.nav;
        nav.scrollLeft += (currentIndexTab.offsetLeft - (nav.offsetWidth - currentIndexTab.offsetWidth) / 2 - nav.scrollLeft) / scrollDuration;
        if (++count < scrollDuration) {
          window.requestAnimationFrame(step);
        }
      };
      window.requestAnimationFrame(step);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-61599f3c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/tab/tab.vue
var tab_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-tab-wrap",class:_vm.barPosition === 'top' ? 'vux-tab-bar-top' : ''},[_c('div',{staticClass:"vux-tab-container"},[_c('div',{ref:"nav",staticClass:"vux-tab",class:[{'vux-tab-no-animate': !_vm.animate},{ scrollable: _vm.scrollable }]},[_vm._t("default"),_vm._v(" "),(_vm.animate)?_c('div',{staticClass:"vux-tab-ink-bar",class:_vm.barClass,style:(_vm.barStyle)},[(_vm.customBarWidth)?_c('span',{staticClass:"vux-tab-bar-inner",style:(_vm.innerBarStyle)}):_vm._e()]):_vm._e()],2)])])}
var tab_staticRenderFns = []
var tab_esExports = { render: tab_render, staticRenderFns: tab_staticRenderFns }
/* harmony default export */ var components_tab_tab = (tab_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/tab/tab.vue
function tab_injectStyle (ssrContext) {
  __webpack_require__("Xo9K")
}
var tab_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var tab___vue_template_functional__ = false
/* styles */
var tab___vue_styles__ = tab_injectStyle
/* scopeId */
var tab___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var tab___vue_module_identifier__ = null
var tab_Component = tab_normalizeComponent(
  tab_tab,
  components_tab_tab,
  tab___vue_template_functional__,
  tab___vue_styles__,
  tab___vue_scopeId__,
  tab___vue_module_identifier__
)

/* harmony default export */ var src_components_tab_tab = (tab_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/tab/tab-item.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var tab_item = ({
  name: 'tab-item',
  mixins: [multi_items["a" /* childMixin */]],
  props: {
    activeClass: String,
    disabled: Boolean,
    badgeBackground: {
      type: String,
      default: '#f74c31'
    },
    badgeColor: {
      type: String,
      default: '#fff'
    },
    badgeLabel: String
  },
  computed: {
    style: function style() {
      return {
        borderWidth: this.$parent.lineWidth + 'px',
        borderColor: this.$parent.activeColor,
        color: this.currentSelected ? this.$parent.activeColor : this.disabled ? this.$parent.disabledColor : this.$parent.defaultColor,
        border: this.$parent.animate ? 'none' : 'auto'
      };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/tab/tab-item.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var tab_tab_item = ({
  name: 'tab-item',
  mixins: [multi_items["a" /* childMixin */]],
  props: {
    activeClass: String,
    disabled: Boolean,
    badgeBackground: {
      type: String,
      default: '#f74c31'
    },
    badgeColor: {
      type: String,
      default: '#fff'
    },
    badgeLabel: String
  },
  computed: {
    style: function style() {
      return {
        borderWidth: this.$parent.lineWidth + 'px',
        borderColor: this.$parent.activeColor,
        color: this.currentSelected ? this.$parent.activeColor : this.disabled ? this.$parent.disabledColor : this.$parent.defaultColor,
        border: this.$parent.animate ? 'none' : 'auto'
      };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9b8ab944","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/tab/tab-item.vue
var tab_item_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-tab-item",class:[_vm.currentSelected ? _vm.activeClass : '', {
    'vux-tab-selected': _vm.currentSelected,
    'vux-tab-disabled': _vm.disabled 
  }],style:(_vm.style),on:{"click":_vm.onItemClick}},[_vm._t("default"),_vm._v(" "),(typeof _vm.badgeLabel !== 'undefined' && _vm.badgeLabel !== '')?_c('span',{staticClass:"vux-tab-item-badge",style:({
      background: _vm.badgeBackground,
      color: _vm.badgeColor
    })},[_vm._v("\n  "+_vm._s(_vm.badgeLabel))]):_vm._e()],2)}
var tab_item_staticRenderFns = []
var tab_item_esExports = { render: tab_item_render, staticRenderFns: tab_item_staticRenderFns }
/* harmony default export */ var components_tab_tab_item = (tab_item_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/tab/tab-item.vue
var tab_item_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var tab_item___vue_template_functional__ = false
/* styles */
var tab_item___vue_styles__ = null
/* scopeId */
var tab_item___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var tab_item___vue_module_identifier__ = null
var tab_item_Component = tab_item_normalizeComponent(
  tab_tab_item,
  components_tab_tab_item,
  tab_item___vue_template_functional__,
  tab_item___vue_styles__,
  tab_item___vue_scopeId__,
  tab_item___vue_module_identifier__
)

/* harmony default export */ var src_components_tab_tab_item = (tab_item_Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-infinite-scroll/vue-infinite-scroll.js
var vue_infinite_scroll = __webpack_require__("bqTm");
var vue_infinite_scroll_default = /*#__PURE__*/__webpack_require__.n(vue_infinite_scroll);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ArticleList.vue







/* harmony default export */ var ArticleList = ({
  components: {
    Tab: src_components_tab_tab, TabItem: src_components_tab_tab_item,
    InlineLoading: vux_src_components_inline_loading
  },
  directives: {
    infiniteScroll: vue_infinite_scroll_default.a
  },
  watch: {
    '$route.params.board': function $routeParamsBoard(board) {
      console.log('board change');
      this.timeout = 0;
      this.board = board;
      this.posts = [];
      this.before = null;
      this.busy = false;
      this.getPost();
    },
    'popular': function popular(_popular) {
      console.log('popular change');
      this.timeout = 0;
      this.popular = _popular;
      this.posts = [];
      this.before = null;
      this.busy = false;
      this.getPost();
    }
  },
  mounted: function mounted() {
    this.board = this.$route.params.board;
  },
  data: function data() {
    return {
      popular: true,
      index: 0,
      tabList: [{ index: 0, name: '熱門', popular: true }, { index: 1, name: '最新', popular: false }],

      board: undefined,
      msg: 'Hello World!',
      posts: [],
      articleLength: 0,
      loading: false,
      before: null,
      timeout: 0,
      busy: false
    };
  },

  methods: {
    colorful: function colorful(g) {
      if (g === 'F') return 'color:rgb(255,192,203);';else if (g === 'M') return 'color:rgb(30,144,255);';else return;
    },
    clickPost: function clickPost(id) {
      this.$router.push('/post/' + id);
    },
    getPost: function getPost() {
      var _this = this;

      if (this.busy) return;
      this.busy = true;

      if (this.articleLength < 30 && this.before !== null) return;
      this.loading = true;

      var api = this.CORS + 'https://www.dcard.tw/_api/';
      if (this.board != undefined) api = api + 'forums/' + this.board + '/';
      var url = api + 'posts';

      this.$http.get(url, {
        params: {
          popular: this.popular,
          before: this.before
        }
      }).then(function (response) {
        _this.articleLength = response.data.length;
        if (_this.articleLength === 30) {
          _this.before = response.data[_this.articleLength - 1].id;
          _this.busy = false;
        } else _this.busy = true;

        _this.posts = _this.posts.concat(response.data);
        _this.loading = false;
      }).catch(function (err) {
        console.log("error:");
        console.log(err);
        _this.loading = "error";
        _this.busy = true;
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ArticleList.vue







/* harmony default export */ var components_ArticleList = ({
  components: {
    Tab: src_components_tab_tab, TabItem: src_components_tab_tab_item,
    InlineLoading: vux_src_components_inline_loading
  },
  directives: {
    infiniteScroll: vue_infinite_scroll_default.a
  },
  watch: {
    '$route.params.board': function $routeParamsBoard(board) {
      console.log('board change');
      this.timeout = 0;
      this.board = board;
      this.posts = [];
      this.before = null;
      this.busy = false;
      this.getPost();
    },
    'popular': function popular(_popular) {
      console.log('popular change');
      this.timeout = 0;
      this.popular = _popular;
      this.posts = [];
      this.before = null;
      this.busy = false;
      this.getPost();
    }
  },
  mounted: function mounted() {
    this.board = this.$route.params.board;
  },
  data: function data() {
    return {
      popular: true,
      index: 0,
      tabList: [{ index: 0, name: '熱門', popular: true }, { index: 1, name: '最新', popular: false }],

      board: undefined,
      msg: 'Hello World!',
      posts: [],
      articleLength: 0,
      loading: false,
      before: null,
      timeout: 0,
      busy: false
    };
  },

  methods: {
    colorful: function colorful(g) {
      if (g === 'F') return 'color:rgb(255,192,203);';else if (g === 'M') return 'color:rgb(30,144,255);';else return;
    },
    clickPost: function clickPost(id) {
      this.$router.push('/post/' + id);
    },
    getPost: function getPost() {
      var _this = this;

      if (this.busy) return;
      this.busy = true;

      if (this.articleLength < 30 && this.before !== null) return;
      this.loading = true;

      var api = this.CORS + 'https://www.dcard.tw/_api/';
      if (this.board != undefined) api = api + 'forums/' + this.board + '/';
      var url = api + 'posts';

      this.$http.get(url, {
        params: {
          popular: this.popular,
          before: this.before
        }
      }).then(function (response) {
        _this.articleLength = response.data.length;
        if (_this.articleLength === 30) {
          _this.before = response.data[_this.articleLength - 1].id;
          _this.busy = false;
        } else _this.busy = true;

        _this.posts = _this.posts.concat(response.data);
        _this.loading = false;
      }).catch(function (err) {
        console.log("error:");
        console.log(err);
        _this.loading = "error";
        _this.busy = true;
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7c073a93","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ArticleList.vue
var ArticleList_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"article"}},[_c('tab',{attrs:{"line-width":2,"active-color":"rgb(86, 167, 212)"},model:{value:(_vm.index),callback:function ($$v) {_vm.index=$$v},expression:"index"}},_vm._l((_vm.tabList),function(item){return _c('tab-item',{key:item.index,on:{"on-item-click":function($event){_vm.popular = item.popular}}},[_vm._v("\n              "+_vm._s(item.name))])})),_vm._v(" "),_c('div',{directives:[{name:"infinite-scroll",rawName:"v-infinite-scroll",value:(_vm.getPost),expression:"getPost"}],attrs:{"infinite-scroll-disabled":"busy"}},[_c('transition-group',{attrs:{"name":"fade","tag":"div"}},_vm._l((_vm.posts),function(p,key){return _c('div',{key:key,staticClass:"post",staticStyle:{"animation-duration":".7s"},on:{"click":function($event){_vm.clickPost(p.id)}}},[_c('span',{staticClass:"gender",style:(_vm.colorful(p.gender))},[_vm._v(_vm._s(p.gender))]),_vm._v(" "),_c('span',{staticClass:"forumName"},[_vm._v(_vm._s(p.forumName))]),_vm._v(" "),_c('span',{staticClass:"school"},[_vm._v(_vm._s(p.school))]),_vm._v(" "),(!p.school)?_c('span',{staticClass:"school"},[_vm._v("匿名")]):_vm._e(),_vm._v(" "),_c('h3',{staticClass:"title"},[_vm._v(_vm._s(p.title))]),_vm._v(" "),_c('p',{staticClass:"excerpt"},[_vm._v(_vm._s(p.excerpt))]),_vm._v(" "),_c('div',{staticStyle:{"opacity":".35"}},[_c('span',{staticClass:"likeCount"},[_vm._v(_vm._s(p.likeCount)+" Likes")]),_vm._v(" "),_c('span',[_vm._v(", ")]),_vm._v(" "),_c('span',{staticClass:"commentCount"},[_vm._v(_vm._s(p.commentCount)+" comments")])])])}))],1),_vm._v(" "),(_vm.loading==true)?_c('div',{staticStyle:{"text-align":"center"}},[_c('br'),_vm._v(" "),_c('inline-loading')],1):(_vm.loading=='error')?_c('div',{staticStyle:{"text-align":"center"}},[_c('br'),_vm._v("\n    Error\n  ")]):_c('div',[(_vm.busy)?_c('p',{staticClass:"more"},[_vm._v("沒有更多文章囉！")]):_c('p',{staticClass:"more"},[_vm._v("上滑查看更多文章")])])],1)}
var ArticleList_staticRenderFns = []
var ArticleList_esExports = { render: ArticleList_render, staticRenderFns: ArticleList_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_ArticleList = (ArticleList_esExports);
// CONCATENATED MODULE: ./src/components/ArticleList.vue
function ArticleList_injectStyle (ssrContext) {
  __webpack_require__("CuW/")
}
var ArticleList_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var ArticleList___vue_template_functional__ = false
/* styles */
var ArticleList___vue_styles__ = ArticleList_injectStyle
/* scopeId */
var ArticleList___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ArticleList___vue_module_identifier__ = null
var ArticleList_Component = ArticleList_normalizeComponent(
  components_ArticleList,
  selectortype_template_index_0_src_components_ArticleList,
  ArticleList___vue_template_functional__,
  ArticleList___vue_styles__,
  ArticleList___vue_scopeId__,
  ArticleList___vue_module_identifier__
)

/* harmony default export */ var src_components_ArticleList = (ArticleList_Component.exports);

// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__("mtWM");
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);

// EXTERNAL MODULE: ./node_modules/vue-axios/dist/vue-axios.min.js
var vue_axios_min = __webpack_require__("Rf8U");
var vue_axios_min_default = /*#__PURE__*/__webpack_require__.n(vue_axios_min);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/postContent.vue





/* harmony default export */ var postContent = ({
  components: {
    InlineLoading: vux_src_components_inline_loading
  },
  directives: {
    infiniteScroll: vue_infinite_scroll_default.a
  },
  watch: {
    '$route.params.postId': function $routeParamsPostId(postId) {
      this.postId = postId;
      console.log(postId);
      this.initial();
    }
  },

  mounted: function mounted() {
    this.initial();
  },
  data: function data() {
    return {
      postId: 0,
      content: [],
      content_loading: true,
      comment_loading: true,
      popular_comment_loading: true,
      after: 0,
      busy: false,
      popular_comments: [],
      comments: [],
      commentsLength: 0

    };
  },

  computed: {},
  methods: {
    colorful: function colorful(g) {
      if (g === 'F') return 'color:rgb(255,192,203);';else if (g === 'M') return 'color:rgb(30,144,255);';else return;
    },
    beautyTime: function beautyTime(time) {
      var t = new Date(time);

      return t.getMonth() + '月' + t.getDate() + '日 ' + t.getHours() + ':' + t.getMinutes();
    },
    initial: function initial() {
      this.postId = this.$route.params.postId;
      this.getContent();
      this.getPopularComments();
      this.getComments();
    },
    getContent: function getContent() {
      var _this = this;

      var api = this.CORS + 'https://www.dcard.tw/_api/posts/';

      this.content_loading = true;
      this.$http.get(api + this.postId).then(function (response) {
        _this.content = response.data;
        _this.content_loading = false;
        console.log(response);
      }).catch(function (err) {
        console.log("error:");
        console.log(err);
        _this.content_loading = "error";
      });
    },
    getPopularComments: function getPopularComments() {
      var _this2 = this;

      var api = this.CORS + 'https://www.dcard.tw/_api/posts/';
      this.comment_loading = true;
      this.$http.get(api + this.postId + '/comments', {
        params: {
          popular: true
        }
      }).then(function (response) {
        _this2.popular_comments = response.data;
        _this2.popular_comment_loading = false;
      }).catch(function (err) {
        console.log("error:");
        console.log(err);
        _this2.popular_comment_loading = "error";
      });
    },
    getComments: function getComments() {
      var _this3 = this;

      if (this.busy) return;
      this.busy = true;

      var api = this.CORS + 'https://www.dcard.tw/_api/posts/';
      this.comment_loading = true;
      this.$http.get(api + this.postId + '/comments', {
        params: {
          after: this.after
        }
      }).then(function (response) {
        _this3.commentsLength = response.data.length;
        if (_this3.commentsLength === 30) {
          _this3.after += 30;
          _this3.busy = false;
        } else _this3.busy = true;
        _this3.comments = _this3.comments.concat(response.data);
        _this3.comment_loading = false;
      }).catch(function (err) {
        console.log("error:");
        console.log(err);
        _this3.comment_loading = "error";
        _this3.busy = true;
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/postContent.vue





/* harmony default export */ var components_postContent = ({
  components: {
    InlineLoading: vux_src_components_inline_loading
  },
  directives: {
    infiniteScroll: vue_infinite_scroll_default.a
  },
  watch: {
    '$route.params.postId': function $routeParamsPostId(postId) {
      this.postId = postId;
      console.log(postId);
      this.initial();
    }
  },

  mounted: function mounted() {
    this.initial();
  },
  data: function data() {
    return {
      postId: 0,
      content: [],
      content_loading: true,
      comment_loading: true,
      popular_comment_loading: true,
      after: 0,
      busy: false,
      popular_comments: [],
      comments: [],
      commentsLength: 0

    };
  },

  computed: {},
  methods: {
    colorful: function colorful(g) {
      if (g === 'F') return 'color:rgb(255,192,203);';else if (g === 'M') return 'color:rgb(30,144,255);';else return;
    },
    beautyTime: function beautyTime(time) {
      var t = new Date(time);

      return t.getMonth() + '月' + t.getDate() + '日 ' + t.getHours() + ':' + t.getMinutes();
    },
    initial: function initial() {
      this.postId = this.$route.params.postId;
      this.getContent();
      this.getPopularComments();
      this.getComments();
    },
    getContent: function getContent() {
      var _this = this;

      var api = this.CORS + 'https://www.dcard.tw/_api/posts/';

      this.content_loading = true;
      this.$http.get(api + this.postId).then(function (response) {
        _this.content = response.data;
        _this.content_loading = false;
        console.log(response);
      }).catch(function (err) {
        console.log("error:");
        console.log(err);
        _this.content_loading = "error";
      });
    },
    getPopularComments: function getPopularComments() {
      var _this2 = this;

      var api = this.CORS + 'https://www.dcard.tw/_api/posts/';
      this.comment_loading = true;
      this.$http.get(api + this.postId + '/comments', {
        params: {
          popular: true
        }
      }).then(function (response) {
        _this2.popular_comments = response.data;
        _this2.popular_comment_loading = false;
      }).catch(function (err) {
        console.log("error:");
        console.log(err);
        _this2.popular_comment_loading = "error";
      });
    },
    getComments: function getComments() {
      var _this3 = this;

      if (this.busy) return;
      this.busy = true;

      var api = this.CORS + 'https://www.dcard.tw/_api/posts/';
      this.comment_loading = true;
      this.$http.get(api + this.postId + '/comments', {
        params: {
          after: this.after
        }
      }).then(function (response) {
        _this3.commentsLength = response.data.length;
        if (_this3.commentsLength === 30) {
          _this3.after += 30;
          _this3.busy = false;
        } else _this3.busy = true;
        _this3.comments = _this3.comments.concat(response.data);
        _this3.comment_loading = false;
      }).catch(function (err) {
        console.log("error:");
        console.log(err);
        _this3.comment_loading = "error";
        _this3.busy = true;
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c931c0e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/postContent.vue
var postContent_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"Post"}},[_c('div',{staticClass:"post-content commentEntry"},[(_vm.content_loading==true)?_c('div',{staticStyle:{"text-align":"center"}},[_c('br'),_vm._v(" "),_c('inline-loading')],1):(_vm.content_loading=='error')?_c('div',{staticStyle:{"text-align":"center"}},[_c('br'),_vm._v("\n      \tError\n      ")]):_c('div',{staticClass:"comment"},[_c('span',{staticClass:"gender",style:(_vm.colorful(_vm.content.gender))},[_vm._v(_vm._s(_vm.content.gender))]),_vm._v(" "),_c('span',{staticClass:"school"},[_vm._v(_vm._s(_vm.content.school))]),_vm._v(" "),(!_vm.content.school)?_c('span',{staticClass:"school"},[_vm._v("匿名")]):_vm._e(),_vm._v(" "),_c('h3',{staticClass:"title"},[_vm._v(_vm._s(_vm.content.title))]),_vm._v(" "),_c('div',{staticClass:"info"},[_c('span',{staticClass:"forumName"},[_vm._v(_vm._s(_vm.content.forumName))]),_vm._v(" "),_c('span',{staticClass:"time"},[_vm._v(_vm._s(_vm.beautyTime(_vm.content.createdAt)))])]),_vm._v(" "),_c('div',[_c('pre',[_vm._v(_vm._s(_vm.content.content))]),_vm._v(" "),_c('div',{staticStyle:{"opacity":".35"}},[_c('span',{staticClass:"likeCount"},[_vm._v(_vm._s(_vm.content.likeCount)+" Likes")]),_vm._v(" "),_c('span',[_vm._v(", ")]),_vm._v(" "),_c('span',{staticClass:"commentCount"},[_vm._v(_vm._s(_vm.content.commentCount)+" comments")])]),_vm._v(" "),_c('div',_vm._l((_vm.content.topics),function(topic){return _c('span',{staticClass:"topic"},[_vm._v(" "+_vm._s(topic)+" ")])}))])])]),_vm._v(" "),(_vm.popular_comments.length!=0)?_c('div',{staticClass:"commentEntry"},[(_vm.popular_comment_loading==true)?_c('div',{staticStyle:{"text-align":"center"}},[_c('br'),_vm._v(" "),_c('inline-loading')],1):(_vm.popular_comment_loading=='error')?_c('div',{staticStyle:{"text-align":"center"}},[_c('br'),_vm._v("\n      \tError\n      ")]):_c('div',{staticClass:"comment"},[_c('span',{staticStyle:{"opacity":".35"}},[_vm._v("熱門回應")]),_vm._v(" "),_vm._l((_vm.popular_comments),function(pc){return _c('div',{staticClass:"content"},[_c('div',[_c('span',{staticClass:"gender",style:(_vm.colorful(_vm.content.gender))},[_vm._v(_vm._s(pc.gender))]),_vm._v(" "),_c('span',{staticClass:"school"},[_vm._v(_vm._s(pc.school))]),_vm._v(" "),(!pc.school)?_c('span',{staticClass:"school"},[_vm._v("匿名")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"info"},[_c('span',{staticClass:"floor"},[_vm._v("B"+_vm._s(pc.floor))]),_vm._v(" "),_c('span',{staticClass:"time"},[_vm._v(_vm._s(_vm.beautyTime(pc.createdAt)))])]),_vm._v(" "),_c('div',[_c('pre',[_vm._v(_vm._s(pc.content))]),_vm._v(" "),_c('p',{staticClass:"likeCount",staticStyle:{"opacity":".35"}},[_vm._v(_vm._s(pc.likeCount)+" likes")])])])})],2)]):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"infinite-scroll",rawName:"v-infinite-scroll",value:(_vm.getComments),expression:"getComments"}],staticClass:"commentEntry",attrs:{"infinite-scroll-disabled":"busy"}},[_c('div',{staticClass:"comment"},[_c('span',{staticStyle:{"opacity":".35"}},[_vm._v("最新回應")]),_vm._v(" "),_c('transition-group',{attrs:{"name":"fade","tag":"div"}},_vm._l((_vm.comments),function(c,key){return _c('div',{key:key,staticClass:"content",staticStyle:{"animation-duration":".7s"}},[_c('div',[_c('span',{staticClass:"gender",style:(_vm.colorful(_vm.content.gender))},[_vm._v(_vm._s(c.gender))]),_vm._v(" "),_c('span',{staticClass:"school"},[_vm._v(_vm._s(c.school))]),_vm._v(" "),(!c.school)?_c('span',{staticClass:"school"},[_vm._v("匿名")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"info"},[_c('span',{staticClass:"floor"},[_vm._v("B"+_vm._s(c.floor))]),_vm._v(" "),_c('span',{staticClass:"time"},[_vm._v(_vm._s(_vm.beautyTime(c.createdAt)))])]),_vm._v(" "),_c('div',[_c('pre',[_vm._v(_vm._s(c.content))]),_vm._v(" "),_c('p',{staticClass:"likeCount",staticStyle:{"opacity":".35"}},[_vm._v(_vm._s(c.likeCount)+" likes")])])])}))],1),_vm._v(" "),(_vm.comment_loading==true)?_c('div',{staticStyle:{"text-align":"center"}},[_c('br'),_vm._v(" "),_c('inline-loading')],1):(_vm.comment_loading=='error')?_c('div',{staticStyle:{"text-align":"center"}},[_c('br'),_vm._v("\n          \tError\n    \t")]):_vm._e()])])}
var postContent_staticRenderFns = []
var postContent_esExports = { render: postContent_render, staticRenderFns: postContent_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_postContent = (postContent_esExports);
// CONCATENATED MODULE: ./src/components/postContent.vue
function postContent_injectStyle (ssrContext) {
  __webpack_require__("qKzq")
}
var postContent_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var postContent___vue_template_functional__ = false
/* styles */
var postContent___vue_styles__ = postContent_injectStyle
/* scopeId */
var postContent___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var postContent___vue_module_identifier__ = null
var postContent_Component = postContent_normalizeComponent(
  components_postContent,
  selectortype_template_index_0_src_components_postContent,
  postContent___vue_template_functional__,
  postContent___vue_styles__,
  postContent___vue_scopeId__,
  postContent___vue_module_identifier__
)

/* harmony default export */ var src_components_postContent = (postContent_Component.exports);

// CONCATENATED MODULE: ./src/main.js
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.








__webpack_require__("6A3X");

vue_esm["a" /* default */].prototype.CORS = Object({"NODE_ENV":"production"}).CORS || 'https://cors-realdennis.herokuapp.com/';

vue_esm["a" /* default */].use(vue_router_esm["a" /* default */]);
vue_esm["a" /* default */].use(vue_axios_min_default.a, axios_default.a);

var routes = [{
  path: '/',
  component: src_components_ArticleList
}, {
  path: '/:board',
  component: src_components_ArticleList
}, {
  path: '/post/:postId',
  component: src_components_postContent
}];

var router = new vue_router_esm["a" /* default */]({
  routes: routes
});

fastclick_default.a.attach(document.body);

vue_esm["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new vue_esm["a" /* default */]({
  router: router,
  render: function render(h) {
    return h(src_App);
  }
}).$mount('#app-box');

/***/ }),

/***/ "Xo9K":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "c9+y":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "owug":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qKzq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tH2/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "y1Ni":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.16899be573ee65afdaf9.js